export default {  
    namespaced: true,
    state: {
        loading: false
    },
    getters: {
        getRequestLoadStatus: state => {
            return state.loading;
          }
    },
    actions: {
        show({ commit }) {
            commit("show");
        },
        hide({ commit }) {
            commit("hide");
        }
    },
    mutations: {
        show(state) {
            state.loading = true;
        },
        hide(state) {
            state.loading = false;
        }
    }
};